import React from 'react';
import { Chip } from '@mui/material';
import { CampaignState } from '@internal/backstage-plugin-bidone-backend';

// Colour mirrors OpsLevel's own state colouring: Draft = neutral, Scheduled =
// info, In Progress = primary, Delayed = warning, Ended = success.
const STATE_COLORS: Record<CampaignState, string> = {
  draft: '#9e9e9e',
  scheduled: '#1976d2',
  in_progress: '#5cb85c',
  delayed: '#ed6c02',
  ended: '#6a1b9a',
};

const STATE_LABELS: Record<CampaignState, string> = {
  draft: 'Draft',
  scheduled: 'Scheduled',
  in_progress: 'In Progress',
  delayed: 'Delayed',
  ended: 'Ended',
};

export const StateLabel = ({ state }: { state: CampaignState }) => (
  <Chip
    size="small"
    label={STATE_LABELS[state]}
    sx={{
      backgroundColor: STATE_COLORS[state],
      color: '#fff',
      fontWeight: 500,
    }}
  />
);
